var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("ChartLine", {
    attrs: {
      "data-testid": "chart-line-testid",
      chartData: _vm.chartData,
      options: _vm.chartOptions,
    },
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }